import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/persons')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/person' })
  },
})
